import { requestPost } from '@/common/request';

export interface saveChannelIntroduceParams {
  fileOperateList: Array<{ name: string; url: string }> | [];
  fileShopList: Array<{ name: string; url: string }> | [];
  remark: string;
}

export interface saveChannelIntroduceRes {
  ret: string;
  msg: string;
}

//
export async function saveChannelIntroduce(params: saveChannelIntroduceParams): Promise<saveChannelIntroduceRes> {
  return await requestPost('/channelActivity/saveChannelIntroduce', params);
}
